import { ISbLink } from '@/utils/interfaces/common';
import { IFeatureTabNoContent } from '@/utils/interfaces/components';
import { useRouter } from 'next/router';
import { useState } from 'react';
import { BrandIcon } from './Icons/BrandIcon';

interface Props {
  tabs: IFeatureTabNoContent[];
  cta: ISbLink;
  ctaLabel: string;
  cached_url?: string;
}

export const FeatureTabsAccordionNoContent: React.FC<Props> = ({
  tabs,
}) => {
  const { locale } = useRouter();

  return (
    <>
      {tabs.map((tab, index) => {
        const cached_url = tab.home_link?.cached_url || '';
        const pathSegments = cached_url.split('/');
        const linkLocale = pathSegments[0];
        const isLocale = /^en-[a-z]{2}$/.test(linkLocale);
        const cleanedUrl = isLocale ? pathSegments.slice(1).join('/') : cached_url;

        return (
          <li key={index} className='py-3 bg-gray-lightest mb-3'>
            <a className='flex items-center gap-3' href={`/${cleanedUrl}`}>
              <span className='w-12 h-12'>
                <BrandIcon label={tab.icon} />
              </span>

              <span className="cursor-pointer font-bold">{tab.label}</span>
            </a>
          </li>
        );
      })}
    </>
  );
};
